/**
 * Upper bound on client-reported reachable route IDs in the context snapshot. The full DMS route
 * catalog is ~700 entries; anything above this cap indicates a malformed client and is rejected.
 */
export const ASSISTANT_REACHABLE_ROUTE_IDS_MAX_ITEMS = 1000;
